import React from 'react'
import PageTitle from '../components/title/PageTitle'
import FeaturesHero from '../components/FeaturesHero'
import FeaturesBlocks from '../components/FeaturesBlocks'
import JumbotronCover from '../components/JumbotronCover'
import FeatureBranchImage from '../assets/images/features/all/feature_branch.png'
import FeatureEmailImage from '../assets/images/features/all/feature_email.png'
import FeatureFeedbackImage from '../assets/images/features/all/feature_feedback.png'
import FeatureFormImage from '../assets/images/features/all/feature_form.png'
import FeatureDepartmentImage from '../assets/images/features/all/feature_department.png'

const FEATURE_OVERVIEW_HERO = {
  badge: 'Features',
  title: 'Discover the features driving today’s customer experience teams.',
  description:
    'Clientshot is more than a feedback inbox. It is a complete system for capturing customer voices, organizing teams, resolving issues, and improving satisfaction at scale.',
  primaryCtaLabel: 'Book a demo',
  primaryCtaHref: 'https://calendly.com/clientshot1/demo-call',
  secondaryCtaLabel: 'Start free',
  secondaryCtaHref: 'https://app.clientshot.com/sign-up',
}

const FEATURE_IMAGES = {
  branches: FeatureBranchImage,
  'email-campaign': FeatureEmailImage,
  feedback: FeatureFeedbackImage,
  forms: FeatureFormImage,
  department: FeatureDepartmentImage,
}

const ALL_FEATURE_BLOCKS = [
  {
    title: 'Forms',
    description:
      'Build dynamic forms, link questions to other forms, merge workflows, and collect structured feedback at scale.',
    ctaLabel: 'Explore Forms',
    ctaHref: '/features/forms',
    image: {
      src: FEATURE_IMAGES.forms,
      alt: 'Forms feature preview',
    },
  },
  {
    title: 'Feedback',
    description:
      'Capture complaints and commendations from Web, USSD, and WhatsApp in one centralized dashboard.',
    ctaLabel: 'Explore Feedback',
    ctaHref: '/features/feedback',
    image: {
      src: FEATURE_IMAGES.feedback,
      alt: 'Feedback feature preview',
    },
  },
  {
    title: 'Departments',
    description:
      'Organize tickets by department, assign team leads, and create clear ownership for faster resolution.',
    ctaLabel: 'Explore Departments',
    ctaHref: '/features/department',
    image: {
      src: FEATURE_IMAGES.department,
      alt: 'Departments feature preview',
    },
  },
  {
    title: 'Email Campaigns',
    description:
      'Create templates, segment audiences, and send targeted follow-ups powered by real feedback data.',
    ctaLabel: 'Explore Email Campaigns',
    ctaHref: '/features/email-campaign',
    image: {
      src: FEATURE_IMAGES['email-campaign'],
      alt: 'Email campaigns feature preview',
    },
  },
  {
    title: 'Branch',
    description:
      'Organize feedback by location so each branch can track what matters, while HQ sees performance across all sites without manual reporting.',
    ctaLabel: 'Explore Branch',
    ctaHref: '/features/branches',
    image: {
      src: FEATURE_IMAGES.branches,
      alt: 'Branch feature preview',
    },
  },
]

const ALL_FEATURES_BOTTOM_CTA = {
  title: 'Ready to See the Full Power of Clientshot?',
  ctaPrimary: 'Book a Demo',
  ctaSecondary: 'Start free',
}

const FeaturesOverview = () => {
  return (
    <div>
      <PageTitle title="Features | Clientshot Website " />
      <FeaturesHero content={FEATURE_OVERVIEW_HERO} />
      <FeaturesBlocks content={ALL_FEATURE_BLOCKS} />
      <JumbotronCover
        title={ALL_FEATURES_BOTTOM_CTA.title}
        description={ALL_FEATURES_BOTTOM_CTA.description}
        primaryAction={{
          label: ALL_FEATURES_BOTTOM_CTA.ctaPrimary,
          href: 'https://calendly.com/clientshot1/demo-call',
          external: true,
        }}
        secondaryAction={{
          label: ALL_FEATURES_BOTTOM_CTA.ctaSecondary,
          href: 'https://app.clientshot.com/sign-up',
          external: true,
        }}
      />
    </div>
  )
}

export default FeaturesOverview
